import {
  AUDITINFO_STATE,
  FEEAUDITSTATeNameMap,
  AUDITINFO_STATE_LOG,
  WORK_PROCESS_GROUP,
  WROK_PROCESS_DATE_STATUS,
  WORK_PROCESS_STATUS,
  WORK_PROCESS_GROUP_STATUS,
  WROK_PROCESS_GROUP_DATE_STATUS,
  RECOVER_AUDIT_STATE,
} from './enum';

// 生产单状态
export const ORDER_STATUS = {
  DRAFT: 1, // 草稿
  PROCESSING: 2, // 生产中
  COMPLETE: 3, // 生产完成
  WAITPROCESS: 4, // 待生产
  WITHDRAW: 9, // 撤销
  // 待接单
  WAITACCEPT: 11,
  // 拒绝接单
  REJECTACCEPT: 12,
  OVERDUE: 9999, // 超过交货日期
};

// 生产单状态列表
export const BASE_ORDER_STATUS_OPTIONS = [
  {
    text: '草稿',
    val: ORDER_STATUS.DRAFT,
  },
  {
    text: '待生产',
    val: ORDER_STATUS.WAITPROCESS,
  },
  {
    text: '生产中',
    val: ORDER_STATUS.PROCESSING,
  },
  {
    text: '生产完成',
    val: ORDER_STATUS.COMPLETE,
  },
  {
    text: '撤销',
    val: ORDER_STATUS.WITHDRAW,
  },
  {
    text: '待接单',
    val: ORDER_STATUS.WAITACCEPT,
  },
  {
    text: '拒绝接单',
    val: ORDER_STATUS.REJECTACCEPT,
  },
];

// 生产单状态
export const PURCHASE_STATE = {
  SUFFICIENT: 1, // 库存充足
  UNPURCHASED: 2, // 未采购
  WAIT: 3, // 待入库
  PART: 4, // 部分入库
  END: 5, // 采购完成
};
// 裁床状态列表
export const CUTTING_BED_STATUS_OPTIONS = [
  {
    text: '全部',
    val: 0,
  },
  {
    text: '不包含裁床',
    val: 1,
  },
  {
    text: '待裁床',
    val: 2,
  },
  {
    text: '裁床中',
    val: 3,
  },
  {
    text: '已完成',
    val: 4,
  },
];
// 入库状态列表
export const STORED_STATUS_OPTIONS = [
  {
    text: '全部',
    val: 0,
  },
  {
    text: '未入库',
    val: 1,
  },
  {
    text: '部分入库',
    val: 2,
  },
  {
    text: '全部入库',
    val: 3,
  },
];
// 领料状态列表
export const PICK_STATUS_OPTIONS = [
  {
    text: '全部',
    val: 0,
  },
  {
    text: '未领料',
    val: 1,
  },
  {
    text: '已领料',
    val: 2,
  },
  // {
  //   text: '缺料',
  //   val: 3,
  // },
];
// 生产单状态列表
export const ORDER_STATUS_OPTIONS = [
  {
    text: '默认',
    val: 0,
  },
  {
    text: '草稿',
    val: ORDER_STATUS.DRAFT,
    color: 'plainBlue',
  },
  {
    text: '待接单',
    val: ORDER_STATUS.WAITACCEPT,
    orderCountField: 'waitAcceptCount',
    color: 'gray',
  },
  {
    text: '拒绝接单',
    val: ORDER_STATUS.REJECTACCEPT,
    orderCountField: 'rejectAcceptCount',
    color: 'red',
  },
  {
    text: '待生产',
    val: ORDER_STATUS.WAITPROCESS,
    orderCountField: 'produceWaitOrderCount',
    color: 'orangeRed',
  },
  {
    text: '生产中',
    val: ORDER_STATUS.PROCESSING,
    orderCountField: 'produceInOrderCount',
    color: 'orange',
  },
  {
    text: '超期',
    val: ORDER_STATUS.OVERDUE,
    orderCountField: 'timeoutOrderCount',
    color: 'red',
  },
  {
    text: '生产完成',
    val: ORDER_STATUS.COMPLETE,
    color: 'green',
  },
  {
    text: '撤销',
    val: ORDER_STATUS.WITHDRAW,
    color: 'gray',
  },
];
// 报价审核
export const ORDER_AUDIT_STATUS_OPTIONS = [
  {
    text: '待报价',
    val: `processFeeAuditTabs${AUDITINFO_STATE.WAIT_SUBMIT}`,
    orderCountField: 'processFeeWaiSubmit',
    type: 'processFeeAuditStates',
    color: 'gray',
  },
  {
    text: '待审核',
    val: `processFeeAuditTabs${AUDITINFO_STATE.WAIT_AUDIT}`,
    orderCountField: 'processFeeWaiAudit',
    type: 'processFeeAuditStates',
    color: 'orange',
  },
  {
    text: '已拒绝',
    val: `processFeeAuditTabs${AUDITINFO_STATE.REJECT}`,
    orderCountField: 'processFeeReject',
    type: 'processFeeAuditStates',
    color: 'red',
  },
];
// 生产单类型
export const PRDUCE_CATEGORY_OPTIONS = [
  {
    name: '全部',
    code: 0,
  },
  {
    name: '自主生产',
    code: 1,
  },
  {
    name: '单工序外发',
    code: 2,
  },
  {
    name: '委外加工',
    code: 3,
  },
  {
    name: '成品采购',
    code: 4,
  },
];
// 外发状态 2-已完成 9-已撤销
export const OUTWARD_STATE = [
  {
    text: '草稿',
    val: 1,
    color: 'blue',
  },
  {
    text: '已完成',
    val: 2,
    color: 'green',
  },
  {
    text: '已撤销',
    val: 9,
    color: 'gray',
  },
];
// 核销状态 1-未核销 2-部分核销 3-已核销
export const RECEIPT_STATE = [
  {
    name: '全部',
    code: 0,
  },
  {
    name: '未核销',
    code: 1,
  },
  {
    name: '部分核销',
    code: 2,
  },
  {
    name: '已核销',
    code: 3,
  },
];
//  1-首单 2-客户订单 3-返单
export const ORDER_TYPE_OPTIONS = [
  {
    name: '首单',
    code: 1,
  },
  {
    name: '客户订单',
    code: 2,
  },
  {
    name: '返单',
    code: 3,
  },
];

export const INBOUND_ORDER_STATE = [
  {
    name: '默认',
    code: 0,
  },
  {
    name: '草稿',
    code: 1,
    color: 'plainBlue',
  },
  {
    name: '待复核',
    code: 4,
    color: 'orangeRed',
  },
  {
    name: '部分复核',
    code: 5,
    color: 'color-orange',
  },
  {
    name: '已复核',
    code: 2,
    color: 'green',
  },
  {
    name: '撤销',
    code: 9,
    color: 'gray',
  },
];
// 回收状态 1-待回收 2-结束回收
export const OUT_SOURCE_STATE = [
  {
    text: '默认',
    val: 0,
  },
  {
    text: '待回收',
    val: 1,
    color: 'gray',
  },
  {
    text: '结束回收',
    val: 2,
    color: 'green',
  },
  {
    text: '已撤销',
    val: 9,
  },
];
export const OUT_SOURCE_TABS = [
  {
    text: '默认',
    val: 0,
  },
  {
    text: '待回收',
    val: 'isWaitRecover',
    color: 'gray',
  },
  {
    text: '待审核',
    val: 'hasWaitAuditRecover',
    color: 'gray',
  },
  {
    text: '部分回收',
    val: 'hasConsentRecover',
    color: 'gray',
  },
  {
    text: '结束回收',
    val: 2,
    color: 'green',
  },
  {
    text: '已撤销',
    val: 9,
  },
];

// 进销存采购单状态
export const IS_PURCHASE_STATE = [
  {
    text: '保存草稿',
    val: 1,
  },
  {
    text: '提交',
    val: 2,
  },
  {
    text: '删除采购单',
    val: 3,
  },
  {
    text: '待入库',
    val: 4,
  },
  {
    text: '部分入库',
    val: 5,
  },
  {
    text: '撤销',
    val: 9,
  },
];

// 发货方式
export const deliveryType: any = {
  1: '自提',
  2: '发物流',
  3: '电子面单',
  4: '送指定点',
  5: '送车',
};

// 编菲选择生产单状态列表
export const WORKTICKET_STATUS_OPTIONS = [
  {
    text: '默认',
    val: 0,
  },
  {
    text: '待生产',
    val: ORDER_STATUS.WAITPROCESS,
    orderCountField: 'produceWaitOrderCount',
    color: 'orangeRed',
  },
  {
    text: '生产中',
    val: ORDER_STATUS.PROCESSING,
    orderCountField: 'produceInOrderCount',
    color: 'orange',
  },
  {
    text: '超期',
    val: ORDER_STATUS.OVERDUE,
    orderCountField: 'timeoutOrderCount',
    color: 'red',
  },
];

// 进销存采购单状态
export const MATERIAL_PURCHASE_STATE = [
  {
    text: '库存充足',
    val: PURCHASE_STATE.SUFFICIENT,
    color: 'blue',
  },
  {
    text: '未采购',
    val: PURCHASE_STATE.UNPURCHASED,
    color: 'color-gray',
  },
  {
    text: '待入库',
    val: PURCHASE_STATE.WAIT,
    color: 'orangeRed',
  },
  {
    text: '部分入库',
    val: PURCHASE_STATE.PART,
    color: 'color-yellow',
  },
  {
    text: '采购完成',
    val: PURCHASE_STATE.END,
    color: 'green',
  },
];
export const AuditStateNameMap: FEEAUDITSTATeNameMap = {
  WAIT_SUBMIT: '待报价',
  WAIT_AUDIT: '待审核',
  PASS: '已同意',
  REJECT: '已拒绝',
};
// 工价审核状态
export const AUDIT_STATE = [
  {
    text: AuditStateNameMap.WAIT_SUBMIT,
    val: AUDITINFO_STATE.WAIT_SUBMIT,
    color: 'gray',
  },
  {
    text: AuditStateNameMap.WAIT_AUDIT,
    val: AUDITINFO_STATE.WAIT_AUDIT,
    color: 'orange',
  },
  {
    text: AuditStateNameMap.PASS,
    val: AUDITINFO_STATE.PASS,
    color: 'green',
  },
  {
    text: AuditStateNameMap.REJECT,
    val: AUDITINFO_STATE.REJECT,
    color: 'red',
  },
];

// 审核状态列表
export const AUDIT_STATUS_OPTIONS = [
  {
    text: '全部',
    val: '',
  },
  ...AUDIT_STATE,
];

// 工价审核日志状态
export const AUDIT_LOG_STATE = [
  {
    val: AUDITINFO_STATE_LOG.PROCESS_FEE_EDIT,
    text: '修改加工费',
    color: 'color-yellow',
  },
  {
    val: AUDITINFO_STATE_LOG.WORKPROCESSEDIT,
    text: '修改工序',
    color: 'color-yellow',
  },
  { val: AUDITINFO_STATE_LOG.REJECT, text: '拒绝', color: 'red' },
  { val: AUDITINFO_STATE_LOG.CONSENT, text: '已同意', color: 'green' },
  { val: AUDITINFO_STATE_LOG.START, text: '开启审核', color: 'color-theme' },
  { val: AUDITINFO_STATE_LOG.CANCEL, text: '取消审核', color: 'color-6296f0' },
  { val: AUDITINFO_STATE_LOG.DESTORY, text: '撤销审核', color: 'gray' },
  { val: AUDITINFO_STATE_LOG.SUBMIT, text: '提交审核', color: 'color-theme' },
];
export function getKeyByValue<T extends number>(
  enumObj: Recordable,
  value: T
): string | undefined {
  return Object.keys(enumObj).find(
    (key) => enumObj[key as keyof typeof enumObj] === value
  );
}

export const WORK_PROCESS_GROUP_STATE = [
  {
    name: '进行中',
    value: WORK_PROCESS_GROUP.PROCESSING,
    bgColor: '#007CFF',
    color: '#007CFF',
  },
  {
    name: '已完成',
    value: WORK_PROCESS_GROUP.COMPLETED,
    bgColor: '#04C160',
    color: '#04C160',
  },
  {
    name: '提前完成',
    value: WORK_PROCESS_GROUP.EARLY_COMPLETED,
    bgColor: '#008D69',
    color: '#008D69 ',
  },
  {
    name: '逾期完成',
    value: WORK_PROCESS_GROUP.OVERDUE_COMPLETED,
    bgColor: '#FB9400',
    color: '#FB9400',
  },
  {
    name: '逾期',
    value: WORK_PROCESS_GROUP.OVERDUE,
    bgColor: 'rgba(255,38,20,0.7)',
    color: 'rgba(255,38,20,0.7)',
  },
  {
    name: '严重逾期',
    value: WORK_PROCESS_GROUP.SEVERE_OVERDUE,
    bgColor: '#FF2614',
    color: '#FF2614',
  },
  {
    name: '未完成',
    value: WORK_PROCESS_GROUP.UNFINISHED,
    bgColor: '#8D8E8E',
    color: '#8D8E8E',
  },
  {
    name: '待进行',
    value: WORK_PROCESS_GROUP.WAIT_PROCESS,
    bgColor: '#8D8E8E',
    color: '#8D8E8E',
  },
];

// 工序状态
export const WORK_PROCESS_STATUS_OPTIONS = [
  {
    text: '全部',
    val: WORK_PROCESS_STATUS.ALL,
  },
  {
    text: '未完成',
    val: WORK_PROCESS_STATUS.UNFINISHED,
  },
  {
    text: '已完成',
    val: WORK_PROCESS_STATUS.FINISHED,
  },
];

// 工序实际状态 1-未开始 2-已完成 3-进行中
export const WORK_PROCESS_ACTUAL_STATE = [
  {
    text: '未开始',
    val: 1,
    color: 'orangered',
  },
  {
    text: '进行中',
    val: 3,
    color: 'orange',
  },
  {
    text: '已完成',
    val: 2,
    color: 'green',
  },
];
export const WORK_PROCESS_AUDIT_STATE = [
  {
    text: '未开始',
    val: 0,
    color: 'orangered',
  },
  {
    text: '审批中',
    val: 10,
    color: '#007cff',
  },
  {
    text: '已同意',
    val: 11,
    color: 'green',
  },
  {
    text: '拒绝',
    val: 12,
    color: 'red',
  },
];
// 工序逾期状态
export const WROK_PROCESS_DATE_STATUS_OPTIONS = [
  {
    text: '全部',
    val: WROK_PROCESS_DATE_STATUS.ALL,
  },
  {
    text: '未设置日期',
    val: WROK_PROCESS_DATE_STATUS.UNSETTING,
  },
  {
    text: '未逾期',
    val: WROK_PROCESS_DATE_STATUS.UNOVERDUE,
  },
  {
    text: '逾期',
    val: WROK_PROCESS_DATE_STATUS.OVERDUE,
  },
];

// 工序分组状态
export const WORK_PROCESS_GROUP_STATUS_OPTIONS = [
  {
    text: '全部',
    val: WORK_PROCESS_GROUP_STATUS.ALL,
  },
  {
    text: '未完成',
    val: WORK_PROCESS_GROUP_STATUS.UNFINISHED,
  },
  {
    text: '已完成',
    val: WORK_PROCESS_GROUP_STATUS.FINISHED,
  },
];

// 工序分组逾期状态
export const WROK_PROCESS_GROUP_DATE_STATUS_OPTIONS = [
  {
    text: '全部',
    val: WROK_PROCESS_GROUP_DATE_STATUS.ALL,
  },
  {
    text: '未设置日期',
    val: WROK_PROCESS_GROUP_DATE_STATUS.UNSETTING,
  },
  {
    text: '未逾期',
    val: WROK_PROCESS_GROUP_DATE_STATUS.UNOVERDUE,
  },
  {
    text: '逾期',
    val: WROK_PROCESS_GROUP_DATE_STATUS.OVERDUE,
  },
];

export const RecoverAuditStateNameMap: Record<
  keyof typeof RECOVER_AUDIT_STATE,
  string
> = {
  WAIT_AUDIT: '待审核',
  PASS: '审核通过',
  REJECT: '审核不通过',
};
// 外发回收审核状态
export const RECOVER_AUDIT_STATE_OPTIONS = [
  {
    text: RecoverAuditStateNameMap.WAIT_AUDIT,
    val: RECOVER_AUDIT_STATE.WAIT_AUDIT,
    color: 'gray',
    bg: '#F8F8F9',
    tc: '#6A6C6C',
  },
  {
    text: RecoverAuditStateNameMap.PASS,
    val: RECOVER_AUDIT_STATE.PASS,
    color: 'green',
    bg: '#D6F9E7',
    tc: '#04C160',
  },
  {
    text: RecoverAuditStateNameMap.REJECT,
    val: RECOVER_AUDIT_STATE.REJECT,
    color: 'red',
    bg: '#FFEFEC',
    tc: '#F37C64',
  },
];
export const excessTypeObj: Recordable = {
  /**
   * @description cutBedNumber 裁床数
   */
  cutBedNumber: '裁床数',
  /**
   * @description produceNumber 订单数
   */
  produceNumber: '订单数',
  /**
   * @description lastWorkProcessNumber 上一节点数
   */
  lastWorkProcessNumber: '上一节点数',
  /**
   * @description appointWorkProcess 其他节点
   */
  appointWorkProcess: '其他节点',
};
export const settingImportanceList = [
  {
    text: '无',
    value: 1,
  },
  {
    text: '裁床',
    value: 2,
  },
  {
    text: '纸样',
    value: 6,
  },
  {
    text: '车间生产',
    value: 4,
  },
  {
    text: '尾部',
    value: 5,
  },
  {
    text: '生产完成',
    value: 3,
  },
];
export const reportModeList = [
  {
    text: '汇报整体数量',
    value: 1,
    className: 'w200',
  },
  {
    text: '分色码汇报数量',
    value: 2,
    className: 'w200',
  },
  {
    text: '汇报整体完成',
    value: 3,
    className: 'w200',
  },
  {
    text: '会签',
    value: 4,
    className: 'w200',
  },
  {
    text: '或签',
    value: 5,
    className: 'w200',
  },
];

// 生产类型汇总
export const prodTypeList = [
  {
    text: '委外加工（全工序外发）',
    val: 3,
  },
  {
    text: '单工序外发',
    val: 2,
  },
  {
    text: '自主生产',
    val: 1,
  },
  {
    text: '成品采购',
    val: 4,
  },
];

export const NODE_GROUP = {
  DEFAULT: 1,
  AUDIT: 2,
};

export const nodeGroupList = [
  { text: '默认节点', value: NODE_GROUP.DEFAULT },
  { text: '审批节点', value: NODE_GROUP.AUDIT },
];
export const excessTypeList = [
  { text: '裁床数', value: 'cutBedNumber' },
  { text: '订单数', value: 'produceNumber' },
  { text: '上一节点数', value: 'lastWorkProcessNumber' },
  { text: '其他节点', value: 'appointWorkProcess' },
];
export const excessHandleList = [
  { text: '仅提示', value: 'toast' },
  { text: '禁止提交', value: 'ban' },
];
